export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "reconnecting": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Internet connection error"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trying to connect"])},
          "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["End call"])}
        },
        "callPause": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Another speaker has paused the call"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wait for him to return or end the call"])},
          "titleMinimize": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The call was paused"])},
          "textMinimize": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wait for your speaker"])},
          "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ok"])}
        },
        "loginFailed": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Failed to login"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Something went wrong. Please try again"])},
          "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Close"])}
        },
        "sessionExpired": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Your session has expired"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please login again"])},
          "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sign In"])}
        },
        "pauseCallEnded": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A paused call was ended"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The call with"])},
          "text_2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["was ended"])},
          "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ok"])}
        }
      },
      "ru": {
        "reconnecting": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ошибка подключения к интернету"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Попытка подключения"])},
          "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Завершить вызов"])}
        },
        "callPause": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Другой спикер приостановил вызов"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Подождите, пока он вернется, или завершите разговор"])},
          "titleMinimize": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вызов был приостановлен"])},
          "textMinimize": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Подожди своего спикера"])},
          "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ок"])}
        },
        "loginFailed": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Не удалось войти"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Что-то пошло не так. Пожалуйста, попробуйте еще раз"])},
          "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Закрыть"])}
        },
        "sessionExpired": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ваша сессия истекла"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пожалуйста, войдите снова"])},
          "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Войти"])}
        },
        "pauseCallEnded": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Приостановленный вызов завершен"])},
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вызов с"])},
          "text_2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["был завершен"])},
          "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ок"])}
        }
      }
    }
  })
}
